import React from 'react';

import type { Props as SectionProps } from '@rover/kibble/patterns/Section';

import LandingRoverProtect from '../../components/LandingRoverProtect';
import { PageSectionId, useSectionRef } from '../hooks/useSectionRef';

const SeoLocationRoverProtect = (sectionProps: SectionProps): JSX.Element => {
  const sectionRef = useSectionRef(PageSectionId.RoverGuarantee);

  return <LandingRoverProtect htmlRef={sectionRef} {...sectionProps} />;
};

export default SeoLocationRoverProtect;
